import { Navigate, RouteObject } from "react-router-dom";
import NFeView from "src/pages/Privada/Fiscal/NFe/NFe.View";
import NFeCadastroView from "src/pages/Privada/Fiscal/NFe/Cadastro/NFe.Cadastro";
import NFeCadastroTributacaoView from "src/pages/Privada/Fiscal/NFe/Cadastro/NFe.Cadastro.Tributacao.View";
import NFeCadastroDestinatarioView from "src/pages/Privada/Fiscal/NFe/Cadastro/NFe.Cadastro.Destinatario.View";
import NFeCadastroItemView from "./Cadastro/Itens/NFe.Cadastro.Item.View";
import NFeCadastroPagamentoView from "./Cadastro/Pagamento/NFe.Cadastro.Pagamento.View";
import NFeCadastroOperacaoView from "./Cadastro/NFe.Cadastro.Operacao.View";
import NFeCadastroTransporteView from "./Cadastro/NFe.Cadastro.Transporte.View";
import NFeCadastroModalidadeFreteView from "./Cadastro/NFe.Cadastro.ModalidadeFrete.View";
import NFeCadastroVolumesView from "./Cadastro/Volumes/NFe.Cadastro.Volumes.View";
import NFeCadastroInformacoesAdicionaisView from "./Cadastro/InformacoesAdicionais/NFe.Cadastro.InformacoesAdicionais.View";
import NFeCadastroConsumidorFinalView from "./Cadastro/NFe.Cadastro.ConsumidorFinal.View";
import NFeCadastroDestinoOperacaoView from "./Cadastro/NFe.Cadastro.DestinoOperacao.View";
import NFeEventoView from "./Evento/NFe.Evento.View";
import NFeCadastroFinalidadeView from "./Cadastro/NFe.Cadastro.Finalidade.View";
import NFeCadastroReferenciaView from "./Cadastro/NFe.Cadastro.Referencia.View";

export const NFeRoutes: RouteObject[] = [
  {
    path: "fiscal/nfe",
    element: <NFeView />,
    children: [],
  },
  {
    path: "fiscal/nfe/evento",
    element: <NFeEventoView />,
  },
  {
    path: "fiscal/nfe/cadastro",
    element: <NFeCadastroView />,
    children: [
      { index: true, element: <Navigate to="operacao" replace /> },
      { path: "operacao", element: <NFeCadastroOperacaoView /> },
      { path: "finalidade", element: <NFeCadastroFinalidadeView /> },
      { path: "referencia", element: <NFeCadastroReferenciaView /> },
      { path: "tributacao", element: <NFeCadastroTributacaoView /> },
      { path: "destinatario", element: <NFeCadastroDestinatarioView /> },
      { path: "consumidorfinal", element: <NFeCadastroConsumidorFinalView /> },
      { path: "destinooperacao", element: <NFeCadastroDestinoOperacaoView /> },
      { path: "item", element: <NFeCadastroItemView /> },
      { path: "pagamento", element: <NFeCadastroPagamentoView /> },
      { path: "modalidadefrete", element: <NFeCadastroModalidadeFreteView /> },
      { path: "transporte", element: <NFeCadastroTransporteView /> },
      { path: "volumes", element: <NFeCadastroVolumesView /> },
      {
        path: "informacoesadicionais",
        element: <NFeCadastroInformacoesAdicionaisView />,
      },
    ],
  },
];
